module.exports = __webpack_public_path__ + "static/img/5019_phase_function_Paper_PointsHejduk_Prediction.5b2e475.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5019_phase_function_Paper_PointsHejduk_Prediction.png
// module id = MU4h
// module chunks = 0